import { FadeUp } from "@/lib/motion";

const STATS = [
  { k: "15+", v: "Years of longest client relationships" },
  { k: "1:1", v: "Every client works directly with Todd" },
  { k: "04", v: "Senior specialists, zero hand-offs" },
];

export default function Hero() {
  return (
    <section
      data-testid="hero-section"
      className="relative overflow-hidden bg-white"
    >
      <div className="mx-auto grid max-w-7xl gap-12 px-4 pb-16 pt-36 sm:px-8 lg:grid-cols-[1.05fr_0.95fr] lg:items-start lg:gap-16 lg:px-12 lg:pb-24 lg:pt-48">
        <div>
          <FadeUp>
            <p
              data-testid="hero-eyebrow"
              className="font-mono text-[13px] font-semibold uppercase tracking-[0.2em] text-flame"
            >
              Small Business Marketing &amp; Lead Generation
            </p>
            <h1 className="mt-5 font-display text-4xl font-extrabold leading-[1.02] tracking-tight text-slate-900 sm:text-5xl lg:text-6xl">
              Turn Your Online Marketing Into{" "}
              <span className="text-flame">
                More Leads, Customers &amp; Revenue.
              </span>
            </h1>
            <p className="mt-7 max-w-xl text-lg leading-relaxed text-slate-800 sm:text-xl">
              ZD Design helps established businesses{" "}
              <strong className="font-semibold text-slate-900">
                improve their websites, Google visibility and advertising
              </strong>
              . We connect website design and optimization, SEO, Google Ads,
              Google Business Profile and Facebook advertising to help generate{" "}
              <em>more calls, inquiries and sales</em>.
            </p>
          </FadeUp>
          <FadeUp delay={0.12}>
            <div
              data-testid="hero-owner-line"
              className="mt-8 flex items-center gap-4"
            >
              <img
                src="/img/todd-leather-full.webp"
                alt="Todd Meisler, owner and strategist at ZD Design"
                data-testid="hero-avatar"
                className="h-28 w-28 shrink-0 rounded-full border-2 border-white object-cover object-top shadow-md"
              />
              <div>
                <p className="text-lg font-semibold text-slate-900">
                  Work directly with Todd Meisler, owner and strategist
                </p>
                <p className="mt-0.5 font-mono text-[13px] uppercase tracking-[0.15em] text-faint">
                  97 recommendations · since 2007
                </p>
              </div>
            </div>
          </FadeUp>
          <FadeUp delay={0.2}>
            <dl
              data-testid="hero-stats"
              className="mt-12 grid max-w-lg grid-cols-3 gap-6 border-t border-slate-200 pt-8"
            >
              {STATS.map((s) => (
                <div key={s.k}>
                  <dt className="font-display text-3xl font-extrabold text-slate-900 sm:text-4xl">
                    {s.k}
                  </dt>
                  <dd className="mt-2 text-base leading-snug text-faint">
                    {s.v}
                  </dd>
                </div>
              ))}
            </dl>
          </FadeUp>
        </div>

        <FadeUp delay={0.15}>
          <div
            data-testid="hero-todd-portrait"
            className="relative overflow-hidden rounded-[28px] shadow-[0_16px_36px_-18px_rgba(15,23,42,0.3)]"
          >
            <img
              src="/img/todd-red-chair.webp"
              alt="Todd Meisler, founder and lead strategist at ZD Design"
              data-testid="hero-todd-photo"
              className="aspect-[5/6] w-full select-none object-cover object-top"
            />
            <a
              href="#book"
              data-testid="hero-speak-button"
              className="absolute bottom-[3%] left-[5%] flex w-[62%] flex-col rounded-2xl bg-slate-600 px-4 py-3 text-white shadow-lg transition-colors duration-300 hover:bg-slate-700"
            >
              <span className="font-display text-base font-bold leading-tight sm:text-lg">
                Speak to a Marketing Expert
              </span>
              <span className="mt-1 font-mono text-[11px] uppercase tracking-[0.15em] text-white/80">
                Book your free call
              </span>
            </a>
          </div>
        </FadeUp>
      </div>
    </section>
  );
}
